<template>
  <div class="box-wrap active-box-wrap" :style="boxWrapStyleObj">
    <span class="border-left-top"></span>
    <span class="border-left-bottom"></span>
    <span class="border-right-top"></span>
    <span class="border-right-bottom"></span>
    <div
      class="statis-title bg1"
      style="display: flex; justify-content: center"
      :ref="`${activeType}_statisTitle`"
    >
      <span>{{ title }}</span
      ><span class="split-line">|</span>
      <div class="active-statis">
        <Select
          v-model="timeSolt"
          ref="timeIntervalSelectRef"
          placeholder="全部时段"
          @on-change="changeTimeSolt"
        >
          <Option value="0">全部时段</Option>
          <Option value="3">本学年</Option>
          <Option value="1">近一周</Option>
          <Option value="2">近一月</Option>
        </Select>
      </div>
      <span class="active-box-more-txt click-element" @click="lookMoreData" v-if="channel!='sy'">
        更多
        <i></i>
      </span>
    </div>
    <ul class="active-static-tab" :ref="`${activeType}_staticTabRef`">
      <template v-for="item in tabList">
        <li
          class="active-static-tab-item click-element"
          :class="item.code == tabCode ? 'active-static-tab-item-selected' : ''"
          @click="changeModule(item.code)"
          :title="item.title"
        >
          {{ item.title }}
        </li>
      </template>
    </ul>
    <div class="active-static-tab-content" :style="contentStyleObj">
      <active-content
        :activeType="activeType"
        :tabCode="tabCode"
        ref="activeTypeRef"
        :rankingList="activeTeacherList"
        :gradeList="gradeList"
        :subjectList="subjectList"
        @update-selected-data="updateSelectedData"
      ></active-content>
    </div>
  </div>
</template>

<script>
import {
  findGradeList,
  findSubjectsList,
  findSchoolYears,
  findResourceActiveTeacher,
  findMicroActiveTeacher,
  findHomeworkActiveTeacher,
  findLearningActiveTeacher,
  findInteractActiveTeacher,
} from "../../../service/bigDataApi.js";
import CountUp from "../../../components/countUp.vue";
import activeContent from "./activeContent.vue";

export default {
  name: "active-teacher-statics",
  data() {
    return {
      screenWidth: 0, //屏幕宽度
      boxWrapStyleObj: {
        height: "",
      },
      contentStyleObj: {
        height: "",
      },
      styleObj: {
        width: "100%",
        height: "100%",
      },
      countWeight: 400,
      tabList: [
        {
          code: "resTab",
          title: "分享课件数",
        },
        {
          code: "microTab",
          title: "分享微课数",
        },
        {
          code: "hwTab",
          title: "布置作业数",
        },
        {
          code: "studyTab",
          title: "探究学习",
        },
        {
          code: "interTab",
          title: "互动答疑",
        },
      ],
      timeSolt: "",
      startDate: "",
      endDate: "",
      tabCode: "resTab",
      activeGradeList: [],
      activeClassList: [],
      activeTeacherList: [],
      curActiveGradeData: {}, //当前年级活跃下的统计数据
      gradeList: [],
      subjectList: [],
      gradeId: "",
      subjectId: "",
      phaseGradeIds: "",//当前学段所有年级id，gradeId为空时用它按学段过滤统计
      title: "教师活跃情况",
      activeType: "teacher",
      channel: process.env.VUE_APP_CHANNEL,
    };
  },
  components: {
    CountUp,
    activeContent,
  },
  props: {
    screenHeight: Number,
    titleHeight: Number,
    schoolId: String,
    schoolName: String,
    schoolCode: String,
    phase: { type: String, default: '' },
  },
  watch: {
    screenHeight: "initBoxHeight",
    titleHeight: "initBoxHeight",
    // 父组件学段切换时重新加载数据
    phase() {
      this.gradeId = '';
      this.subjectId = '';
      this.handleSearch();
    },
  },
  computed: {
    // 实际传给统计接口的年级id：选了具体年级用选中值，没选则用学段内所有年级id
    effectiveGradeId() {
      return this.gradeId || this.phaseGradeIds || '';
    }
  },
  methods: {
    /**
     * 初始化box高度
     */
    initBoxHeight() {
      let titleRef = this.activeType + "_statisTitle";
      let tabRef = this.activeType + "_staticTabRef";
      let winHeight = window.innerHeight;
      if (winHeight < 900) {
        winHeight = 938;
      }
      let boxWrapHeight = (winHeight - 128 - 10 - 30) / 3;
      let contentHeight =
        boxWrapHeight -
        this.$refs[titleRef].offsetHeight -
        this.$refs[tabRef].offsetHeight -
        20;
      this.boxWrapStyleObj.height = boxWrapHeight + "px";
      this.contentStyleObj.height = contentHeight + "px";
    },
    /**
     * 获取年级列表
     */
    async getGradeList() {
      let _this = this;
      let param = {
        schoolid: this.schoolId,
      };
      // 优先用父组件传入的学段，其次用用户默认学段
      let phase = this.phase || this.$store.getters.phase || '';
      if (phase) {
        param.phase = phase;
      }
      await findGradeList(param)
        .then(function (data) {
          _this.gradeList = data.rows;
          // 记录当前学段所有年级id，用于不选年级时按学段过滤统计
          if (_this.gradeList && _this.gradeList.length > 0) {
            _this.phaseGradeIds = _this.gradeList.map(g => g.id).join(',');
          } else {
            _this.phaseGradeIds = '';
          }
        })
        .catch(function (error) {
          _this.$Message.error(error.message);
        });
    },
    /**
     * 获取学科列表
     */
    async getSubjectList() {
      let _this = this;
      let param = {
        schoolid: this.schoolId,
      };
      // 优先用父组件传入的学段，其次用用户默认学段
      let phase = this.phase || this.$store.getters.phase || '';
      if (phase) {
        param.phase = phase;
      }
      await findSubjectsList(param)
        .then(function (data) {
          _this.subjectList = data.rows;
        })
        .catch(function (error) {
          _this.$Message.error(error.message);
        });
    },
    /**
     * 获取教师下的作业活跃统计情况
     */
    async getHomeworkActiveTeacher() {
      let _this = this;
      let param = {
        schoolid: this.schoolId,
        gradeid: this.effectiveGradeId,
        subjectid: this.subjectId,
        pageno: 1,
        pagesize: 10,
        top: 5, //取前五
      };
      if (this.startDate && this.endDate) {
        param.startdate = this.startDate;
        param.enddate = this.endDate;
      }
      await findHomeworkActiveTeacher(param)
        .then(function (data) {
          _this.activeTeacherList = [];
          if (Object.keys(data.rows).length > 0) {
            _this.activeTeacherList = data.rows;
            //遍历集合 计算作业提交率和作业批改率
            let calcData = _this.calcHomeworkData(data.rows);
            _this.activeTeacherList = calcData;
          }
        })
        .catch(function (error) {
          _this.$Message.error(error.message);
        });
    },
    /**
     * 获取教师下的微课活跃统计情况
     */
    async getMicroActiveTeacher() {
      let _this = this;
      let param = {
        schoolid: this.schoolId,
        gradeid: this.effectiveGradeId,
        subjectid: this.subjectId,
        pageno: 1,
        pagesize: 10,
        top: 5, //取前五
      };
      if (this.startDate && this.endDate) {
        param.startdate = this.startDate;
        param.enddate = this.endDate;
      }
      await findMicroActiveTeacher(param)
        .then(function (data) {
          _this.activeTeacherList = [];
          if (Object.keys(data.rows).length > 0) {
            _this.activeTeacherList = data.rows;
          }
        })
        .catch(function (error) {
          _this.$Message.error(error.message);
        });
    },
    /**
     * 获取教师下的资源活跃统计情况
     */
    async getResourceActiveTeacher() {
      let _this = this;
      let param = {
        schoolid: this.schoolId,
        gradeid: this.effectiveGradeId,
        subjectid: this.subjectId,
        pageno: 1,
        pagesize: 10,
        top: 5, //取前五
      };
      if (this.startDate && this.endDate) {
        param.startdate = this.startDate;
        param.enddate = this.endDate;
      }
      await findResourceActiveTeacher(param)
        .then(function (data) {
          _this.activeTeacherList = [];
          // _this.activeTeacherList =  [
          //     {
          //         "user_id": "9ddbaf28d9824d0b9c820d70ecba459b",
          //         "understand_rate": 1,
          //         "user_name": "罗杰",
          //         "res_num": 135,
          //         "read_rate": 0.06
          //     },
          //     {
          //         "user_id": "f5ac5cfea3d049cd8cd4ff2529b620ee",
          //         "understand_rate": 0.89,
          //         "user_name": "张玉霞",
          //         "res_num": 40,
          //         "read_rate": 0.18
          //     },
          //     {
          //         "user_id": "df4b4614fbfe47bbbc1e6c35c8874c2b",
          //         "understand_rate": 1,
          //         "user_name": "荀明",
          //         "res_num": 32,
          //         "read_rate": 0.09
          //     },
          //     {
          //         "user_id": "9f7f3fa8cc5a4bfe959ef6fa4d3c79a8",
          //         "understand_rate": 0.87,
          //         "user_name": "余舒静",
          //         "res_num": 30,
          //         "read_rate": 0.47
          //     },
          //     {
          //         "user_id": "406a8daa48094bad81f36ddbd1b3ef57",
          //         "understand_rate": 1,
          //         "user_name": "翰瑜",
          //         "res_num": 27,
          //         "read_rate": 0.07
          //     }
          // ] ;
          if (Object.keys(data.rows).length > 0) {
            _this.activeTeacherList = data.rows;
          }
        })
        .catch(function (error) {
          _this.$Message.error(error.message);
        });
    },
    /**
     * 获取教师下的探究学习活跃统计情况
     */
    async getLearningActiveTeacher() {
      let _this = this;
      let param = {
        schoolid: this.schoolId,
        gradeid: this.effectiveGradeId,
        subjectid: this.subjectId,
        pageno: 1,
        pagesize: 10,
        top: 5, //取前五
      };
      if (this.startDate && this.endDate) {
        param.startdate = this.startDate;
        param.enddate = this.endDate;
      }
      await findLearningActiveTeacher(param)
        .then(function (data) {
          _this.activeTeacherList = [];
          if (Object.keys(data.rows).length > 0) {
            _this.activeTeacherList = data.rows;
          }
        })
        .catch(function (error) {
          _this.$Message.error(error.message);
        });
    },
    /**
     * 获取教师下的互动答疑的活跃统计情况
     */
    async getInteractActiveTeacher() {
      let _this = this;
      let param = {
        schoolid: this.schoolId,
        gradeid: this.effectiveGradeId,
        subjectid: this.subjectId,
        pageno: 1,
        pagesize: 10,
        top: 5, //取前五
      };
      if (this.startDate && this.endDate) {
        param.startdate = this.startDate;
        param.enddate = this.endDate;
      }
      await findInteractActiveTeacher(param)
        .then(function (data) {
          _this.activeTeacherList = [];
          if (Object.keys(data.rows).length > 0) {
            _this.activeTeacherList = data.rows;
          }
        })
        .catch(function (error) {
          _this.$Message.error(error.message);
        });
    },
    /**
     * 计算各年级的作业提交率和作业批改率
     */
    calcHomeworkData(data) {
      for (let i = 0; i < data.length; i++) {
        data[i].hwSubmitRate = this.$utils.toDecimal(
          (data[i].hw_submit_num / data[i].stu_num) * 100
        );
        data[i].hwCorrectRate = this.$utils.toDecimal(
          (data[i].hw_correct_num / data[i].hw_submit_num) * 100
        );
      }
      this.curActiveGradeData = data[0];

      return data;
    },
    /**
     * 选中当前排行榜已选中项
     */
    changeGrade(index) {
      this.curActiveGradeData = this.activeGradeList[index];
    },
    /**
     * 选择时间段
     */
    async changeTimeSolt() {
      let todayStr = this.$utils.getNDayStr(1);
      this.endDate = todayStr + " 23:59:59";
      //获取近一周时间
      if (this.timeSolt === "1") {
        this.startDate = this.$utils.getYestodaySevenDayStr(1) + " 00:00:00";
      } else if (this.timeSolt === "2") {
        //获取近一月时间
        this.startDate = this.$utils.getPreMonthDay(todayStr, 1) + " 00:00:00";
      } else if (this.timeSolt === "3") {
        //获取本学年时间（按学校真实学年起止时间）
        const res = await findSchoolYears({ schoolid: this.schoolId });
        if (res && res.length > 0) {
          this.startDate = res[0].startTime + " 00:00:00";
          this.endDate = res[0].endTime + " 23:59:59";
        }
      } else {
        this.startDate = "";
        this.endDate = "";
      }
      this.handleSearch();
    },
    judgeSchoolYear() {
      let currentDate = new Date().getTime();
      let currentSchoolYear = new Date(
        new Date().getFullYear() + "-08-10 00:00:00"
      ).getTime();
      if (currentDate < currentSchoolYear) {
        return new Date().getFullYear() - 1;
      } else {
        return new Date().getFullYear();
      }
    },
    /**
     * 根据type和当前tab获取相应数据
     */
    changeModule(val) {
      this.tabCode = val;
      // this.timeSolt = "";
      // this.startDate = "";
      // this.endDate = "";
      // this.$refs.timeIntervalSelectRef.clearSingleSelect();
      if (this.$refs.activeTypeRef) {
        this.$refs.activeTypeRef.initParams();
      }
      this.handleSearch();
    },
    /**
     * 根据不同的情况请求数据
     */
    handleSearch() {
      switch (this.tabCode) {
        case "hwTab":
          this.getHomeworkActiveTeacher();
          break;
        case "microTab":
          this.getMicroActiveTeacher();
          break;
        case "resTab":
          this.getResourceActiveTeacher();
          break;
        case "studyTab":
          this.getLearningActiveTeacher();
          break;
        case "interTab":
          this.getInteractActiveTeacher();
          break;
        default:
          this.getHomeworkActiveTeacher();
          break;
      }
    },
    /**
     * 更新当前选中的学科id或年级id
     */
    updateSelectedData(subjectId, gradeId) {
      this.subjectId = subjectId;
      this.gradeId = gradeId;
      this.handleSearch();
    },
    /**
     * 查看更多数据信息
     */
    lookMoreData() {
      let routeData = this.$router.resolve({
        name: "actstatisdetails",
        query: {
          schoolId: this.schoolId,
          schoolName: this.schoolName,
          schoolCode: this.schoolCode,
          activeType: this.activeType,
          tabCode: this.tabCode,
          activeTypeName: "教师活跃情况",
        },
      });
      window.open(routeData.href, "_blank");
    },
  },
  mounted() {
    this.getGradeList();
    this.getSubjectList();
    this.changeModule("resTab");
  },
};
</script>

<style lang="scss" scoped>
@import "../../../style/databoard";
@import "../../../style/layout";

.bg1 {
  background-image: url("../../../assets/images/sydataboard/title-bg.png");
}

.active-static-tab{
  border-bottom: 1px solid #a1b6eb;
}
.active-static-tab-item {
  // background-image: url("../../../assets/images/databoard/icon_tab_normal.png");
color: #fff;

}

.active-static-tab-item-selected {
  // background-image: url("../../../assets/images/databoard/icon_tab_hover.png");
  color: #2B7FFF;
  border-bottom: 1px solid #2B7FFF;
}

.active-box-more-txt i {
  background-image: url(../../../assets/images/databoard/active-icon.png);
  background-position: -299px 90px;
}

.active-static-icon-arrow-down {
  background-image: url(../../../assets/images/databoard/active-icon.png);
  background-position: -224px 90px;
}
</style>

<style lang="scss">
.active-statis {
  .ivu-select-selection {
    box-shadow: transparent !important;
    background-color: transparent !important;
    border: transparent !important;
  }
  .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
  .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
    font-size: 16px !important;
    color: #ffffff !important;
  }
  .ivu-select-arrow {
    color: #ffffff !important;
  }

  .ivu-select-dropdown {
    max-height: 100px;
    background: rgba(10, 18, 39, 0.97);
    box-shadow: inset 0px 0px 10px 4px rgba(14, 252, 255, 0.15) !important;
    border-radius: 5px;
  }
  .ivu-select-item {
    color: #ffffff !important;
    text-align: center;
  }

  .ivu-select-item:hover {
    background: #ffffff !important;
    color: #0a1227 !important;
  }

  .ivu-select-item-focus {
    background: #ffffff !important;
    color: #0a1227 !important;
  }
}
</style>
